module.exports = __webpack_public_path__ + "img/empty-contents.1294c2b8.svg";